'use client';

import { ComponentProps } from 'react';
import { default as BreadcrumbLayout } from '@alltrails/layout/components/Breadcrumbs';
import usePublicBaseUrl from '@alltrails/context/hooks/usePublicBaseUrl';
import logBreadcrumbLinkClicked from '@alltrails/amplitude/events/logBreadcrumbLinkClicked';
import PageType from '@alltrails/amplitude/enums/PageType';
import styles from './Breadcrumbs.module.scss';
import { LocationDetailsApiResponse } from '@/types/locationDetailsPages/shared';

type BreadcrumbsProps = {
  orderedBreadcrumbList: LocationDetailsApiResponse['orderedBreadcrumbList'];
  pageType?: PageType;
};

type BreadcrumbLayoutBreadcrumbs = ComponentProps<typeof BreadcrumbLayout>['breadcrumbItems'];

const mapBreadcrumb = (breadcrumb: LocationDetailsApiResponse['orderedBreadcrumbList'][number], pageType?: PageType) => ({
  name: breadcrumb.name!,
  url: `/${breadcrumb.urlPath}`,
  onClick: (index: number) => {
    if (pageType) {
      logBreadcrumbLinkClicked({
        click_text: breadcrumb.name!,
        page_type: pageType,
        position_available: String(index),
        url: String(breadcrumb.urlPath)
      });
    }
  }
});

const Breadcrumbs = ({ orderedBreadcrumbList, pageType }: BreadcrumbsProps) => {
  const publicBaseUrl = usePublicBaseUrl();

  const mappedBreadcrumbs = orderedBreadcrumbList.reduce((breadcrumbs: BreadcrumbLayoutBreadcrumbs, breadcrumb) => {
    if (breadcrumb.name) {
      breadcrumbs.push(mapBreadcrumb(breadcrumb, pageType));
    }
    return breadcrumbs;
  }, []);

  return <BreadcrumbLayout breadcrumbItems={mappedBreadcrumbs} className={styles.breadcrumbs} pageType={pageType} baseUrl={publicBaseUrl} />;
};

export default Breadcrumbs;
